import React, { useState } from "react";
import FilterTab from "../../common/Filter"; // adjust the path
import { FilterIcon } from "../../assets/Icons";


const FilterBtn = ({ selectedCheckboxes, handleCheckboxChange, handleReset, filterOptions=[] }) => {
  const [showFilter, setShowFilter] = useState(false);

  return (
    <>
      <div className="filterbtn gradient-border">
        <button className=" btninadjust position-relative  " onClick={() => setShowFilter(!showFilter)}>
          <FilterIcon /> {selectedCheckboxes.length > 0 && <span className="filter-active-span"></span>}
        </button>
      </div>

      <FilterTab
        selectedCheckboxes={selectedCheckboxes}
        setSelectedCheckboxes={handleCheckboxChange}
        filterOptions={filterOptions}
        onToggleFilter={() => setShowFilter(false)}
        showfilter={showFilter}
        handleResetCheckBox={handleReset}
      />

      {/* <div className="mt-4">
        <h4>Selected Filters:</h4>
        <ul>
          {selectedCheckboxes.map((item) => (
            <li key={item.key}>{item.name}</li>
          ))}
        </ul>
      </div> */}
    </>
  );
};

export default FilterBtn;
